import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { refType } from '@material-ui/utils';
import InputBase from '../InputBase';
import NotchedOutline from './NotchedOutline';
import withStyles from '../styles/withStyles';
export var styles = function styles(theme) {
  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    
    root: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover $notchedOutline': {
        borderColor: theme.palette.text.primary
      },
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        '&:hover $notchedOutline': {
          borderColor: borderColor
        }
      },
      '&$focused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2
      },
      '&$error $notchedOutline': {
        borderColor: theme.palette.error.main
      },
      '&$disabled $notchedOutline': {
        borderColor: theme.palette.action.disabled
      }
    },

    
    colorSecondary: {
      '&$focused $notchedOutline': {
        borderColor: theme.palette.secondary.main
      }
    },

    
    focused: {},

    
    disabled: {},

    
    adornedStart: {
      paddingLeft: 14
    },

    
    adornedEnd: {
      paddingRight: 14
    },

    
    error: {},

    
    marginDense: {},

    
    multiline: {
      padding: '18.5px 14px',
      '&$marginDense': {
        paddingTop: 10.5,
        paddingBottom: 10.5
      }
    },

    
    notchedOutline: {
      borderColor: borderColor
    },

    
    input: {
      padding: '18.5px 14px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderRadius: 'inherit'
      }
    },

    
    inputMarginDense: {
      paddingTop: 10.5,
      paddingBottom: 10.5
    },

    
    inputMultiline: {
      padding: 0
    },

    
    inputAdornedStart: {
      paddingLeft: 0
    },

    
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var OutlinedInput = React.forwardRef(function OutlinedInput(props, ref) {
  var classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      label = props.label,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      notched = props.notched,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = _objectWithoutProperties(props, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);

  return React.createElement(InputBase, _extends({
    renderSuffix: function renderSuffix(state) {
      return React.createElement(NotchedOutline, {
        className: classes.notchedOutline,
        label: label,
        labelWidth: labelWidth,
        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
      });
    },
    classes: _extends({}, classes, {
      root: clsx(classes.root, classes.underline),
      notchedOutline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
process.env.NODE_ENV !== "production" ? OutlinedInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  
  autoComplete: PropTypes.string,

  
  autoFocus: PropTypes.bool,

  
  classes: PropTypes.object,

  
  color: PropTypes.oneOf(['primary', 'secondary']),

  
  defaultValue: PropTypes.any,

  
  disabled: PropTypes.bool,

  
  endAdornment: PropTypes.node,

  
  error: PropTypes.bool,

  
  fullWidth: PropTypes.bool,

  
  id: PropTypes.string,

  
  inputComponent: PropTypes.elementType,

  
  inputProps: PropTypes.object,

  
  inputRef: refType,

  
  label: PropTypes.node,

  
  labelWidth: PropTypes.number,

  
  margin: PropTypes.oneOf(['dense', 'none']),

  
  multiline: PropTypes.bool,

  
  name: PropTypes.string,

  
  notched: PropTypes.bool,

  
  onChange: PropTypes.func,

  
  placeholder: PropTypes.string,

  
  readOnly: PropTypes.bool,

  
  required: PropTypes.bool,

  
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  
  startAdornment: PropTypes.node,

  
  type: PropTypes.string,

  
  value: PropTypes.any
} : void 0;
OutlinedInput.muiName = 'Input';
export default withStyles(styles, {
  name: 'MuiOutlinedInput'
})(OutlinedInput);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/OutlinedInput/OutlinedInput.js
// module id = 969
// module chunks = 0